export function formatPersonName(value: string | null | undefined): string {
  return (value ?? '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

export function round2(value: number | null | undefined): number | null {
  if (value == null || !Number.isFinite(value)) return null
  return Math.round((value + Number.EPSILON) * 100) / 100
}

export function formatRate(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '0.00'
  return value.toFixed(2)
}
